
import { VListItem } from "vuetify/lib";

export default VListItem.extend({});
